// extracted by mini-css-extract-plugin
export default {"button":"HvPwlI","hiddenLabel":"pFrNlV"};